export default __webpack_public_path__ + "static/media/global-search-banner.a4125102.jpg";